module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/X-Men-Days-of-Future-Past.224edf3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/X-Men-Days-of-Future-Past.jpg
// module id = 1EtR
// module chunks = 0